import { useEffect, useState } from "react";

export function useDetectSticky(
  refWithPositionSticky: React.RefObject<HTMLElement | null>,
  observerSettings: IntersectionObserverInit = {},
) {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (!refWithPositionSticky.current) return;

    const element = refWithPositionSticky.current;

    const sentinel = document.createElement("div");
    sentinel.style.position = "absolute";
    sentinel.style.top = "1px";
    sentinel.style.left = "0";
    sentinel.style.right = "0";
    sentinel.style.height = "1px";
    sentinel.style.pointerEvents = "none";

    element.parentNode?.insertBefore(sentinel, element);

    const observer = new IntersectionObserver(
      ([entry]) => {
        // When sentinel goes out of view, sticky element is stuck
        setIsSticky(!entry.isIntersecting);
      },
      {
        threshold: [1],
        ...observerSettings,
      },
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
      sentinel.remove();
    };
  }, [refWithPositionSticky, observerSettings]);

  return { isSticky };
}
